import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { SIZES } from '../Common/constants';

import SearchIcon from 'dibs-icons/exports/MagnifyingGlass';
import { StyledButton } from '../Common/Button/StyledButton';

// styles
import styles from './main.scss';

const { small, medium, large } = SIZES;

type ButtonProps = {
    dataTn: string;
    size: typeof small | typeof medium | typeof large;
    disabled?: boolean;
    hideClearButton?: boolean;
    ariaLabel?: string;
    type: 'left' | 'right';
};

export const SearchButton: FunctionComponent<ButtonProps> = ({
    dataTn,
    size,
    disabled = false,
    hideClearButton = true,
    ariaLabel = 'Search',
    type,
}) => {
    // default to medium size
    let sizeSearch = styles.mediumSearch;
    if (size === 'small') {
        sizeSearch = styles.smallSearch;
    } else if (size === 'large') {
        sizeSearch = styles.largeSearch;
    }
    const searchButtonClasses = classnames({
        [styles.defaultSearch]: !size,
        [sizeSearch]: !!size,
        [styles.noClick]: hideClearButton,
        [styles.fullyTransparent]: hideClearButton || type === 'left',
        [styles.whiteFill]: type === 'right' && !hideClearButton,
    });

    const buttonProps = {
        className: searchButtonClasses,
        dataTn,
        disabled,
        isPrimary: type === 'right' ? !hideClearButton : false,
    };

    return (
        <StyledButton type="submit" ariaLabel={ariaLabel} {...buttonProps}>
            <SearchIcon />
        </StyledButton>
    );
};
